import { useState } from "react";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import styles from "./ExpandingOptions.module.css";

import casa1 from "assets/images/CASA5.webp";
import casa2 from "assets/images/CASA6.webp";
import casa3 from "assets/images/CASA3.webp";
import casa4 from "assets/images/CASA4.webp";

const ICONS = ["workspace_premium", "villa", "favorite", "schedule"];

const BG_IMAGES = [`url(${casa1})`, `url(${casa2})`, `url(${casa3})`, `url(${casa4})`];

function ExpandingOptions({ items }) {
  const [active, setActive] = useState(0);

  return (
    <div className={styles.options}>
      {items.map((item, i) => (
        <div
          key={i}
          className={`${styles.option} ${active === i ? styles.active : ""}`}
          style={{ "--optionBackground": BG_IMAGES[i % BG_IMAGES.length] }}
          onClick={() => setActive(i)}
        >
          <div className={styles.shadow} />
          <div className={styles.label}>
            <div className={styles.iconBox}>
              <Icon sx={{ fontSize: "1.2rem", color: "inherit" }}>{ICONS[i % ICONS.length]}</Icon>
            </div>
            <div className={styles.info}>
              <div className={styles.main}>{item.value}</div>
              <div className={styles.sub}>{item.label}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

ExpandingOptions.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ExpandingOptions;
